import isEmpty from "lodash-es/isEmpty";
import { Button, DeleteIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { EfsMelcoEfsModelsUserFormatListItem } from "melco-shared-logic";
import { Key } from "antd/lib/table/interface";
import { useConfirm } from "../../hooks/useConfirm";
import { useDeleteDataMappings } from "../../hooks/inputFormats/useDeleteDataMappings";

type BulkActionDeleteDataMappingsProps<T> = {
  selectedRowKeys: Key[];
  setSelectedRowKeys: (keys: Key[]) => void;
  refetch?: () => Promise<any>;
  data?: T[];
};

export const BulkActionDeleteDataMappings: React.FC<
  BulkActionDeleteDataMappingsProps<EfsMelcoEfsModelsUserFormatListItem>
> = ({ selectedRowKeys, setSelectedRowKeys, refetch }) => {
  const { t } = useTranslation();
  const deleteDataMappings = useDeleteDataMappings();

  const confirmDelete = useConfirm(
    async () => {
      const successfullyDeletedIds = await deleteDataMappings(
        selectedRowKeys.map((key) => key.toString())
      );

      if (refetch) {
        refetch();
      }

      // keep items that were not deleted selected
      setSelectedRowKeys(
        selectedRowKeys.filter(
          (id) => !successfullyDeletedIds.includes(id.toString())
        )
      );
    },
    {
      translationPrefix: "dataMappings.list.actions.delete",
      translationOptions: {
        count: selectedRowKeys.length,
      },
    }
  );

  if (isEmpty(selectedRowKeys)) {
    return null;
  }

  return (
    <Button
      key="bulk-delete"
      icon={<DeleteIcon />}
      onClick={() => {
        confirmDelete();
      }}
    >
      {t("dataMappings.list.actions.delete.button")}
    </Button>
  );
};
